<template>
  <span class="edi-report">
    <edi-dialog :value="showDialog" @input="showDialog = $event" v-if="isLogged">
      <template #activator="{open}">
        <button class="button-rs bg-report active">
            <span @click.prevent.stop="open">He visto un error <strong>⚠️</strong></span>
        </button>
      </template>
      <edi-report-form
        :page-id="pageId"
        @success="showDialog = false"
        @cancel="showDialog = false"></edi-report-form>
    </edi-dialog>
    <template v-else>
        <span class="button-rs bg-report active">
            <span @click.prevent.stop="showError = true">He visto un error
                <strong>⚠️</strong>
            </span>
        </span>
      <transition name="slide-fade">
        <edi-error
          v-if="showError"
          :text="'reportar un error'"
          @click:cancel="clearError"
          @destroy="clearError"></edi-error>
      </transition>
    </template>
  </span>
</template>

<script>
  import EdiDialog from '../components/EdiDialog';
  import EdiReportForm from './EdiReportForm';
  import EdiReportBtn from './EdiReportBtn';
  import EdiError from "../components/EdiError";

  import {mapGetters} from 'vuex';

  export default {
    name: 'edi-report',
    props: {
      pageId: {
        type: Number,
        optional: true,
      }
    },
    components: {
      EdiError,
      EdiDialog,
      EdiReportForm,
      EdiReportBtn
    },
    computed: {
      ...mapGetters(['isLogged'])
    },
    data() {
      return {
        showDialog: false,
        showError: false,
        showErrorTimeout: null
      }
    },
    methods: {
      reportNotLogged() {
        this.showError = true;
        this.showErrorTimeout = setTimeout(() => {
          this.showError = false;
        }, 3000);
      },
      clearError() {
        this.showError = false;
        clearTimeout(this.showErrorTimeout)
      }
    }
  }
</script>

<style>
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
